<template>
  <div>
    <Ad title="展望未来 诚邀加盟"
        desc="我有技术 有产品 有平台，如果你懂营销 运营 请务必联系我们 一起携手共创美好明天！"
        :bg="require('@/assets/images/index/ads/ad3.jpeg')"
    >
      <div class="zy-container" style="text-align: center;margin-top: 40px;">
        <el-button plain style="background: #00000000;color:white;border-color: white;" @click="goLogin">前往咨询</el-button>
        <el-button @click="goLogin">立即登录/注册</el-button>
      </div>

    </Ad>
    <Contact/>
    <div class="zy-footer">
<!--      <el-image class="navbar-brand" alt="" :src="logo2"-->
<!--                style="margin-right: 20px;height: 41px;"/>-->
      <!-- FOOTER -->
      <footer class="footerBottom">
        <!-- 测试服 http://test-official.izhyin.com/ -->
        <!-- 			<span style="margin-top: 20px">
                © 2008-2022 智莺科技 版权所有
                <a href="http://beian.miit.gov.cn" target="_blank">渝ICP备20004491号</a>
              </span> -->

        <!-- 正式服 -->
        <span style="margin-top: 20px">
				© 2008-2022 广东智莺科技有限公司 珠海方诺信息科技有限公司 版权所有
        <a href="http://beian.miit.gov.cn" target="_blank">粤ICP备2021007547号-4</a>
			</span>

        <a href="http://beian.miit.gov.cn" target="_blank">粤ICP备13020798号 &nbsp;<span>粤公网安备 44049002000552</span></a>

      </footer>
    </div>
  </div>
</template>

<script>
import Contact from "./Contact.vue"
import Ad from '@/views/index/widgets/Ad.vue'

export default {
  components: {Contact, Ad},
  data() {
    return {
      logo2: require('@/assets/images/index/logo2.png'),
    }
  },
  methods: {
    goLogin: function () {
      this.$router.push("/login");
    },
  }
}
</script>

<style scoped>
.zy-footer {
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 60px;
  padding-right: 60px;
  padding-bottom: 40px;
}

.footerBottom {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666666;
  font-size: 14px;
  margin-top: 10px;
}
</style>
